import moment from "moment";
import React from "react";
import { Field } from "redux-form";
import { renderCurrency, renderNumberKG } from "../../../Utils/renderField/renderField";
import CardEmpty from "../../../Utils/Cards/CardEmpty";
import { between0and1Field, positiveNumberField, requiredField, maxFloatField } from "../../../Utils/renderField/hookForms";

/**
 * Componente para configurar valores default de bonificación por uso de fletes
 * @param {function} onSubmit - Función para manejar el envío del formulario
 * @param {object} configuraciones - Objeto con las configuraciones actuales
 * @returns {JSX.Element} - Componente de configuración de bonificación por uso de fletes
 */
export default function BonifFletes({ onSubmit, configuraciones }) {

    return (
        <div className="mt-3">
            <CardEmpty noShadow>
                <div className="row col-12">
                    <div className="col-12 d-flex justify-content-between align-configuracioness-baseline">
                        <h6 className="mb-3">VALORES DEFAULT PARA BONIFICACIÓN POR USO DE SERVICIO FLETES</h6>
                    </div>
                </div>
                <div className="row  col-md-12 p-0">
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="bonif_fletes_min_kg" className="m-0">VALOR MÍNIMO DE KILOGRAMOS</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <div className="ml-4">
                                <Field name="bonif_fletes_min_kg"
                                    component={renderNumberKG} decimalScale={2}
                                    type="text" className="form-control"
                                    allowNegative={false}
                                    validate={[requiredField, positiveNumberField, maxFloatField]}
                                />
                                <small
                                    className="gris"
                                >Última actualización: {moment(configuraciones.modificado).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="bonif_fletes_bono_por_kg" className="m-0">BONO POR KILOGRAMO</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <div className="ml-4">
                                <Field name="bonif_fletes_bono_por_kg"
                                    component={renderCurrency} prefix="$ " decimalScale={4}
                                    type="text" className="form-control"
                                    allowNegative={false}
                                    validate={[requiredField, between0and1Field]}
                                />
                                <small
                                    className="gris"
                                >Última actualización: {moment(configuraciones.modificado).format('DD/MM/YYYY HH:mm:ss')}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </CardEmpty>
        </div>
    );
}
